// VNEC v9 — pages/don-hang.js
// Đơn hàng theo HĐ Nguyên tắc — lưu vào bảng don_hang (header) + don_hang_items (chi tiết).
// Mã ĐH theo format v8: {MaHDKhung}/DH-{NNN} — gen qua RPC get_next_dh_suffix.
import { supabase, getCurrentUser, submitForApproval } from '../lib/supabase.js';
import { formatVND, parseVND, stateLabel, attachVNDFormat, esc } from '../lib/forms.js';
import { getNextMaDH } from '../lib/naming.js';

let _state = { rows: [], user: null, loaiCPList: [] };

export function renderDonHang() {
  window.__pageInit = initDonHang;
  return `
    <div class="crud-wrap">
      <div class="page-hd">
        <h2>Đơn hàng (DH) — HĐ Nguyên tắc</h2>
        <div>
          <button class="btn btn-primary btn-sm" id="dh-new">+ Tạo đơn hàng</button>
          <button class="btn btn-ghost btn-sm" id="dh-refresh">⟳</button>
        </div>
      </div>
      <div class="crud-filters">
        <input type="text" class="inp" id="f-search" placeholder="Tìm mã ĐH, HĐ khung, nhà thầu…" style="min-width:280px">
      </div>
      <div id="dh-table" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>
      <div id="dh-modal" class="modal-overlay" style="display:none"></div>
    </div>`;
}

async function initDonHang() {
  _state.user = await getCurrentUser();
  // Cache loai_cp list từ ifrs_rules
  try {
    const { data } = await supabase.from('ifrs_rules').select('loai_cp, note').order('loai_cp');
    _state.loaiCPList = (data || []).map(r => ({ loai_cp: r.loai_cp, mo_ta: r.note }));
  } catch (e) { _state.loaiCPList = []; }
  document.getElementById('dh-new').addEventListener('click', () => openForm());
  document.getElementById('dh-refresh').addEventListener('click', load);
  const fSearch = document.getElementById('f-search');

  // Auto-filter from HD list "view-dh" quick action
  const filterParent = sessionStorage.getItem('vnec_filter_parent_dh');
  if (filterParent) {
    sessionStorage.removeItem('vnec_filter_parent_dh');
    fSearch.value = filterParent;
  }

  fSearch.addEventListener('input', renderTable);
  await load();

  // Auto-open form from HD list "+ ĐH" quick action
  const prefillDH = sessionStorage.getItem('vnec_prefill_parent_dh');
  if (prefillDH) {
    sessionStorage.removeItem('vnec_prefill_parent_dh');
    setTimeout(() => openForm(null, prefillDH), 100);
  }
}

async function load() {
  try {
    const { data, error } = await supabase.from('don_hang')
      .select('id, so_dh, ma_hd, ma_hd_khung, nha_thau, ma_du_an, tong_gia_tri, trang_thai, created_at, don_hang_items(count)')
      .is('deleted_at', null).order('created_at', { ascending: false }).limit(1000);
    if (error) throw error;
    _state.rows = (data || []).map(r => ({
      id: r.id,
      so_dh: r.so_dh || r.ma_hd,
      parent: r.ma_hd_khung || '',
      nha_thau: r.nha_thau || '',
      ma_du_an: r.ma_du_an || '',
      tong_tt: Number(r.tong_gia_tri || 0),
      count: r.don_hang_items?.[0]?.count || 0,
      trang_thai: r.trang_thai,
      created_at: r.created_at
    }));
    renderTable();
  } catch (e) {
    document.getElementById('dh-table').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderTable() {
  const q = (document.getElementById('f-search').value || '').toLowerCase();
  const rows = _state.rows.filter(r =>
    !q || (r.so_dh || '').toLowerCase().includes(q)
       || (r.parent || '').toLowerCase().includes(q)
       || (r.nha_thau || '').toLowerCase().includes(q)
  );
  if (!rows.length) { document.getElementById('dh-table').innerHTML = '<div class="empty">Chưa có đơn hàng</div>'; return; }

  let html = '<table class="tbl"><thead><tr><th>Mã ĐH</th><th>HĐ khung</th><th>Nhà thầu</th><th class="c">Số HM</th><th class="r">Tổng GT</th><th class="c">Trạng thái</th><th class="c">Thao tác</th></tr></thead><tbody>';
  rows.forEach(r => {
    html += `<tr>
      <td><b>${esc(r.so_dh)}</b></td>
      <td class="small">${esc(r.parent)}</td>
      <td>${esc(r.nha_thau)}</td>
      <td class="c">${r.count}</td>
      <td class="r money">${formatVND(r.tong_tt)}</td>
      <td class="c">${stateLabel(r.trang_thai)}</td>
      <td class="c">
        <button class="btn-mini view" data-act="view" data-id="${r.id}">Xem</button>
        ${r.trang_thai === 'draft' || r.trang_thai === 'rejected' ? `<button class="btn-mini" data-act="edit" data-id="${r.id}" style="background:#534AB7;color:#fff">Sửa</button>` : ''}
        ${r.trang_thai === 'draft' ? `<button class="btn-mini submit" data-act="submit" data-id="${r.id}" data-key="${esc(r.so_dh)}">Gửi duyệt</button>` : ''}
        ${r.trang_thai === 'draft' ? `<button class="btn-mini reject" data-act="delete" data-id="${r.id}">Xóa</button>` : ''}
      </td>
    </tr>`;
  });
  html += '</tbody></table>';
  document.getElementById('dh-table').innerHTML = html;

  document.querySelectorAll('#dh-table button[data-act]').forEach(btn => {
    btn.addEventListener('click', () => {
      const act = btn.dataset.act;
      if (act === 'view') viewDH(btn.dataset.id);
      else if (act === 'edit') openForm(btn.dataset.id);
      else if (act === 'delete') doDelete(btn.dataset.id);
      else if (act === 'submit') doSubmit(btn.dataset.id, btn.dataset.key);
    });
  });
}

async function openForm(editId = null, prefillParent = null) {
  const modal = document.getElementById('dh-modal');
  modal.style.display = 'flex';
  modal.innerHTML = '<div class="modal-box"><div class="m-body"><div class="loading">Đang tải...</div></div></div>';

  // Load existing if edit mode
  let existing = null;
  if (editId) {
    const { data, error } = await supabase.from('don_hang')
      .select('*, don_hang_items(*)').eq('id', editId).maybeSingle();
    if (error || !data) {
      modal.innerHTML = `<div class="modal-box"><div class="m-body"><div class="error-box">Không tải được ĐH: ${error?.message || 'không tìm thấy'}</div></div></div>`;
      return;
    }
    if (data.trang_thai !== 'draft' && data.trang_thai !== 'rejected') {
      modal.innerHTML = `<div class="modal-box"><div class="m-body"><div class="error-box">Chỉ sửa được ĐH ở trạng thái draft hoặc rejected. Trạng thái hiện tại: ${data.trang_thai}</div></div></div>`;
      return;
    }
    existing = data;
  }

  // Parents: HĐ Nguyên tắc đã duyệt
  const { data: parents } = await supabase.from('hop_dong')
    .select('id, so_hd, ma_hd, nha_thau, ma_du_an, phan_loai_hd')
    .eq('trang_thai', 'approved').is('deleted_at', null)
    .or('phan_loai_hd.eq.HDNT,phan_loai_hd.ilike.%nguyên%')
    .limit(500);
  const parentList = parents || [];

  const parentVal = existing?.ma_hd_khung || prefillParent || '';

  modal.innerHTML = `
    <div class="modal-box modal-lg">
      <div class="m-hd"><div class="m-title">${editId ? 'Sửa đơn hàng: ' + esc(existing.ma_hd || existing.so_dh) : 'Tạo đơn hàng mới'}</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        <form id="dh-form" data-edit-id="${editId || ''}">
          <div class="fg">
            <label class="field"><span>HĐ khung (Nguyên tắc) *</span>
              <select name="parent" class="inp" required id="sel-parent" ${editId ? 'data-locked="1" style="background:#EEEDFE;color:#534AB7;pointer-events:none;font-weight:700"' : ''}>
                <option value="">— Chọn HĐ khung đã duyệt —</option>
                ${parentList.map(p => {
                  const val = p.ma_hd || p.so_hd;
                  const sel = val === parentVal ? 'selected' : '';
                  return `<option value="${esc(val)}" data-ma-du-an="${esc(p.ma_du_an || '')}" data-ncc="${esc(p.nha_thau || '')}" ${sel}>${esc(val)} — ${esc(p.nha_thau || '')}</option>`;
                }).join('')}
              </select>
            </label>
            <label class="field"><span>Nhà thầu</span><input name="nha_thau" class="inp" id="inp-ncc" value="${esc(existing?.nha_thau || '')}"></label>
          </div>
          <div class="rows-hd"><h4>Hạng mục đơn hàng</h4><button type="button" class="btn btn-ghost btn-sm" id="add-row">+ Thêm dòng</button></div>
          <table class="rows-tbl">
            <thead><tr><th style="width:30px">#</th><th>Nội dung</th><th style="width:80px">ĐVT</th><th class="r" style="width:90px">SL</th><th class="r" style="width:130px">Đơn giá</th><th class="r" style="width:130px">Thành tiền</th><th style="width:160px">Loại CP *</th><th style="width:30px"></th></tr></thead>
            <tbody id="rows-body"></tbody>
            <tfoot><tr class="ttl"><td colspan="5" class="r">TỔNG</td><td class="r money" id="total-cell">0</td><td colspan="2"></td></tr></tfoot>
          </table>
          <div class="modal-actions">
            <button type="button" class="btn btn-ghost" id="cancel">Hủy</button>
            <button type="submit" class="btn btn-primary">${editId ? 'Cập nhật' : 'Lưu nháp'}</button>
          </div>
        </form>
      </div>
    </div>`;

  const body = document.getElementById('rows-body');
  if (existing) {
    const items = (existing.don_hang_items || []).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
    if (items.length) {
      items.forEach(it => addRowToForm(body, it));
    } else {
      addRowToForm(body);
    }
    updateTotal(body);
  } else {
    addRowToForm(body);
  }

  document.getElementById('sel-parent').addEventListener('change', e => {
    const opt = e.target.selectedOptions[0];
    document.getElementById('inp-ncc').value = opt?.dataset?.ncc || '';
  });

  // Trigger change to fill nha_thau if pre-selected
  if (parentVal && !existing) {
    const sel = document.getElementById('sel-parent');
    if (sel.value === parentVal) sel.dispatchEvent(new Event('change'));
  }

  document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('cancel').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('add-row').addEventListener('click', () => addRowToForm(body));
  document.getElementById('dh-form').addEventListener('submit', e => { e.preventDefault(); submitForm(); });
}

function addRowToForm(body, prefill = null) {
  const tr = document.createElement('tr');
  const idx = body.children.length + 1;
  const lcpOpts = _state.loaiCPList.map(r =>
    `<option value="${esc(r.loai_cp)}"${prefill && prefill.loai_cp === r.loai_cp ? ' selected' : ''}>${esc(r.loai_cp)}${r.mo_ta ? ' — ' + esc(r.mo_ta) : ''}</option>`
  ).join('');
  const sl = prefill ? formatVND(prefill.so_luong) : '1';
  const dg = prefill ? formatVND(prefill.don_gia) : '';
  const tt = prefill ? formatVND(Number(prefill.so_luong) * Number(prefill.don_gia)) : '';
  tr.innerHTML = `
    <td class="c">${idx}</td>
    <td><input class="inp" name="noi_dung" required value="${esc(prefill?.noi_dung || '')}"></td>
    <td><input class="inp" name="don_vi" placeholder="VD: m3" value="${esc(prefill?.don_vi || '')}"></td>
    <td><input class="inp r" name="so_luong" value="${sl}"></td>
    <td><input class="inp r" name="don_gia" value="${dg}"></td>
    <td><input class="inp r" name="thanh_tien" readonly style="background:#F4F4FB" value="${tt}"></td>
    <td><select class="inp" name="loai_cp" required><option value="">-- Chọn --</option>${lcpOpts}</select></td>
    <td class="c"><button type="button" class="btn-mini reject" data-act="del">×</button></td>`;
  body.appendChild(tr);
  const slEl = tr.querySelector('[name="so_luong"]');
  const dgEl = tr.querySelector('[name="don_gia"]');
  const ttEl = tr.querySelector('[name="thanh_tien"]');
  attachVNDFormat(slEl); attachVNDFormat(dgEl);
  const calc = () => {
    ttEl.value = formatVND(parseVND(slEl.value) * parseVND(dgEl.value));
    updateTotal(body);
  };
  slEl.addEventListener('input', calc);
  dgEl.addEventListener('input', calc);
  tr.querySelector('[data-act="del"]').addEventListener('click', () => {
    tr.remove();
    [...body.children].forEach((el, i) => el.children[0].textContent = i + 1);
    updateTotal(body);
  });
}

function updateTotal(body) {
  let total = 0;
  body.querySelectorAll('[name="thanh_tien"]').forEach(i => total += parseVND(i.value));
  const cell = document.getElementById('total-cell');
  if (cell) cell.textContent = formatVND(total);
}

async function submitForm() {
  const form = document.getElementById('dh-form');
  const editId = form.dataset.editId || null;
  const fd = new FormData(form);
  // Defensive: read parent from select.value if FormData missed it (e.g. disabled select)
  const selParent = document.getElementById('sel-parent');
  const parent = fd.get('parent') || selParent.value;
  const nha_thau = (fd.get('nha_thau') || '').trim();
  if (!parent) { toast('Chọn HĐ khung', 'err'); return; }

  // Find parent info
  const opt = selParent.selectedOptions[0];
  const ma_du_an = opt?.dataset?.maDuAn || null;

  const body = document.getElementById('rows-body');
  let hasMissingLcp = false;
  const rows = [...body.children].map((tr, i) => {
    const lcp = tr.querySelector('[name="loai_cp"]').value;
    const nd = tr.querySelector('[name="noi_dung"]').value.trim();
    if (nd && !lcp) hasMissingLcp = true;
    return {
      sort_order: i,
      noi_dung: nd,
      don_vi: tr.querySelector('[name="don_vi"]').value.trim() || null,
      so_luong: parseVND(tr.querySelector('[name="so_luong"]').value),
      don_gia: parseVND(tr.querySelector('[name="don_gia"]').value),
      loai_cp: lcp || null
    };
  }).filter(r => r.noi_dung);
  if (hasMissingLcp) { toast('Có dòng thiếu Loại CP', 'err'); return; }
  if (!rows.length) { toast('Thêm ít nhất 1 hạng mục', 'err'); return; }

  const tongTT = rows.reduce((s, r) => s + r.so_luong * r.don_gia, 0);

  try {
    if (editId) {
      // UPDATE existing
      const { error: uErr } = await supabase.from('don_hang').update({
        nha_thau: nha_thau || null,
        ma_du_an: ma_du_an || null,
        tong_gia_tri: tongTT
      }).eq('id', editId);
      if (uErr) throw uErr;

      // Replace items: delete + insert
      const { error: dErr } = await supabase.from('don_hang_items').delete().eq('don_hang_id', editId);
      if (dErr) throw dErr;

      const itemRows = rows.map(r => ({
        don_hang_id: editId,
        sort_order: r.sort_order,
        noi_dung: r.noi_dung,
        don_vi: r.don_vi,
        so_luong: r.so_luong,
        don_gia: r.don_gia,
        loai_cp: r.loai_cp
      }));
      const { error: iErr } = await supabase.from('don_hang_items').insert(itemRows);
      if (iErr) throw iErr;

      toast('Đã cập nhật đơn hàng', 'ok');
    } else {
      // INSERT new
      const maDH = await getNextMaDH(parent);
      const { data: newDH, error: cErr } = await supabase.from('don_hang').insert({
        ma_hd: maDH,
        ma_hd_khung: parent,
        nha_thau: nha_thau || null,
        ma_du_an: ma_du_an || null,
        tong_gia_tri: tongTT,
        trang_thai: 'draft'
      }).select('id').single();
      if (cErr) throw cErr;

      const itemRows = rows.map(r => ({
        don_hang_id: newDH.id,
        sort_order: r.sort_order,
        noi_dung: r.noi_dung,
        don_vi: r.don_vi,
        so_luong: r.so_luong,
        don_gia: r.don_gia,
        loai_cp: r.loai_cp
      }));
      const { error: iErr } = await supabase.from('don_hang_items').insert(itemRows);
      if (iErr) throw iErr;

      toast('Đã tạo: ' + maDH, 'ok');
    }
    document.getElementById('dh-modal').style.display = 'none';
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function viewDH(id) {
  const { data } = await supabase.from('don_hang').select('*, don_hang_items(*)').eq('id', id).maybeSingle();
  if (!data) return;
  const items = (data.don_hang_items || []).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  const modal = document.getElementById('dh-modal');
  modal.style.display = 'flex';
  let total = 0;
  const rowsHtml = items.map((it, i) => {
    const tt = Number(it.thanh_tien) || 0; total += tt;
    return `<tr><td class="c">${i + 1}</td><td>${esc(it.noi_dung || '')}</td><td>${esc(it.don_vi || '')}</td><td class="r">${formatVND(it.so_luong)}</td><td class="r">${formatVND(it.don_gia)}</td><td class="r money">${formatVND(tt)}</td></tr>`;
  }).join('');
  modal.innerHTML = `
    <div class="modal-box modal-lg">
      <div class="m-hd"><div class="m-title">Chi tiết: ${esc(data.ma_hd || data.so_dh)} ${stateLabel(data.trang_thai)}</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        <p class="muted small">HĐ khung: <strong>${esc(data.ma_hd_khung || '')}</strong> • Nhà thầu: ${esc(data.nha_thau || '')} • Dự án: ${esc(data.ma_du_an || '')}</p>
        <table class="mt"><thead><tr><th>#</th><th>Nội dung</th><th>ĐVT</th><th class="r">SL</th><th class="r">Đơn giá</th><th class="r">Thành tiền</th></tr></thead>
        <tbody>${rowsHtml}<tr class="ttl"><td colspan="5" class="r">TỔNG</td><td class="r money">${formatVND(total)}</td></tr></tbody></table>
      </div>
    </div>`;
  document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
}

async function doDelete(id) {
  if (!confirm('Xóa đơn hàng này?')) return;
  try {
    const { error } = await supabase.from('don_hang').update({ deleted_at: new Date().toISOString() }).eq('id', id);
    if (error) throw error;
    toast('Đã xóa', 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function doSubmit(id, label) {
  if (!confirm(`Gửi duyệt ${label}?`)) return;
  try {
    await submitForApproval('don_hang', id);
    toast('Đã gửi duyệt', 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

function toast(msg, type='ok') {
  const c = document.getElementById('toast-container'); if (!c) { alert(msg); return; }
  const el = document.createElement('div'); el.className = 'toast toast-' + type; el.textContent = msg;
  c.appendChild(el); setTimeout(() => el.remove(), 3500);
}
